import { PrimaryButton } from '@fluentui/react'
import React from 'react'

const AddButton = (props) => {
    const addIcon = {iconName: 'Add'};
  return (
        <PrimaryButton
            //iconProps={addIcon}
            text={`${props.text}`}
            style={{
                fontSize: "13px",
                fontWeight: "600",
                lineHeight: "20px",
                marginTop: "10px",
                marginBottom: "12px"
            }}
        />
  )
}

export default AddButton